import { PropertyOwnerPermissionType } from 'models/Owner';
import FormWithProvider from 'components/forms/form/Form';
import { Modal } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import { TableItemOwner } from '../../PropertySettingsOwnersTab.types';
import OwnerPermissionsModalFooter from './OwnerPermissionsModalFooter';
import {
  formSchema,
  OwnerPermissionsFormSchemaType,
} from './OwnerPermissionsModal.schema';
import { ModalContainer } from './OwnerPermissionsModal.styles';
import { OwnerPermissionsFormFields } from './OwnerPermissionsFormFields';

export const ownerPermissionsModalId = 'owner-permissions-modal';

type Props = {
  owner: TableItemOwner;
  onSubmit: (values: OwnerPermissionsFormSchemaType) => void | Promise<unknown>;
};

const OwnerPermissionsModal = ({ owner, onSubmit }: Props) => {
  const { t } = useTranslation();
  const { closeModal } = useAppModal();

  const handleClose = () => {
    closeModal(ownerPermissionsModalId);
  };

  const getDefaultValues = () => {
    const checkPermission = (permission: PropertyOwnerPermissionType) =>
      owner?.permissionTypes?.includes(permission);

    return {
      uid: owner?.uid,
      formula: owner?.formula,
      [PropertyOwnerPermissionType.READING_CALENDAR]: checkPermission(
        PropertyOwnerPermissionType.READING_CALENDAR,
      ),
      [PropertyOwnerPermissionType.READING_BOOKING_DETAILS]: checkPermission(
        PropertyOwnerPermissionType.READING_BOOKING_DETAILS,
      ),
      [PropertyOwnerPermissionType.READING_BOOKING_VALUE]: checkPermission(
        PropertyOwnerPermissionType.READING_BOOKING_VALUE,
      ),
      [PropertyOwnerPermissionType.CREATING_BLOCKS]: checkPermission(
        PropertyOwnerPermissionType.CREATING_BLOCKS,
      ),
      [PropertyOwnerPermissionType.VIEW_ANALYTICS]: checkPermission(
        PropertyOwnerPermissionType.VIEW_ANALYTICS,
      ),
    };
  };

  const handleSubmit = async (values: OwnerPermissionsFormSchemaType) => {
    await onSubmit(values);
  };

  return (
    <FormWithProvider
      horizontal
      onSubmit={handleSubmit}
      defaultValues={getDefaultValues()}
      resolver={formSchema}
    >
      <ModalContainer>
        <Modal.Header closeButton>
          <Modal.Title>
            <Trans
              i18nKey="pageProperty.owners.permissionsModal.title"
              values={{ ownerName: owner?.fullName }}
              components={{ 1: <span className="green" /> }}
            />
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{t('pageProperty.owners.permissionsModal.description')}</p>

          <OwnerPermissionsFormFields />
        </Modal.Body>

        <OwnerPermissionsModalFooter onClose={handleClose} />
      </ModalContainer>
    </FormWithProvider>
  );
};

export default OwnerPermissionsModal;
